// src/components/CustomDropdown.js

import React, { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";

const CustomDropdown = ({ options, value, onChange, label = "" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Fecha o dropdown se o utilizador clicar fora dele
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (optionValue) => {
    onChange(optionValue);
    setIsOpen(false);
  };

  const selectedOption = options.find((opt) => opt.value === value) || {
    label: "Selecione",
  };

  return (
    <div className="relative w-full text-left" ref={dropdownRef}>
      {/* Botão que mostra a seleção atual e abre o dropdown */}
      <button
        type="button"
        className="flex w-full items-center justify-between rounded-md bg-gray-700 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 focus:ring-offset-gray-800"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>
          {label && <span className="text-gray-400 mr-2">{label}</span>}
          {selectedOption.label}
        </span>
        <ChevronDown
          className={`h-5 w-5 text-gray-400 transition-transform duration-200 ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>

      {/* Painel com as opções, que aparece e desaparece com uma transição */}
      {isOpen && (
        <div
          className="absolute right-0 z-10 mt-2 w-full origin-top-right rounded-md bg-gray-800 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
          role="menu"
          aria-orientation="vertical"
        >
          <div className="py-1 max-h-60 overflow-y-auto" role="none">
            {options.map((option) => (
              <a
                href="#"
                key={option.value}
                className={`block px-4 py-2 text-sm ${
                  option.value === value
                    ? "bg-teal-600 text-white"
                    : "text-gray-300 hover:bg-gray-700 hover:text-white"
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleSelect(option.value);
                }}
                role="menuitem"
              >
                {option.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
